import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {withFirebase} from 'react-redux-firebase';
import _ from 'lodash';

import LocationIcon from '@material-ui/icons/Place';
import TimeIcon from '@material-ui/icons/DateRange';
import ContactIcon from '@material-ui/icons/MailOutline';
import PeopleIcon from '@material-ui/icons/PeopleOutline';
import WatchLaterIcon from '@material-ui/icons/WatchLater';

import {styles, Countdown} from '../../common';
import {SlideContainer} from '../../common/slideshow';
import {formatDescription, handleClick} from '../../../util/eventHelper';
import firebaseUtils from '../../../util/FirebaseUtils';

import logo from '../../../assets/images/logo-Spiria.png';

const icons = {
    clock: WatchLaterIcon,
    contact: ContactIcon,
    location: LocationIcon,
    participants: PeopleIcon,
    time: TimeIcon
};

const getIcon = (type) => {
    return icons[type];
};

class SpocEventSlide extends React.Component {
    constructor(props, context) {
        super(props, context);
        
        this.state = {
            imageUrl: null
        };
    }    

    componentDidMount() {
        this.getImage();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.image !== this.props.image) {
            this.getImage();
        }
    }

    getImage() {
        const imageToUse = this.props.spocImage || this.props.defaultSpocImage; 

        firebaseUtils.getImageUrl(this.props.firebase, imageToUse)
            .then(imageUrl => this.setState({imageUrl: imageUrl || logo}));
    }

    getOptionalFields(rest) {
        return Object.keys(rest || {})
            .reduce((acc, key) => {
                const value = do {
                    if (!rest.timeOverride && rest[key] && key === 'time' && moment(rest[key]).isValid()) {
                        if (moment.isMoment(rest[key])) {
                            rest[key].format('LLLL');
                        } else {
                            moment(rest[key]).format('LLLL');
                        }
                    } else {
                        rest[key];
                    }
                };
                if ((typeof value === 'number' && value > 1) || (typeof value === 'string' && value.trim() !== '')) {
                    const Icon = getIcon(key);
                    if (Icon) {
                        acc.push(
                            <div key={key} className={key}>
                                <Icon/>
                                <span>{value}</span>
                            </div>
                        );
                    }
                }
                return acc;
            }, []);
    }

    render() {
        const {description, fontSettings, onLoad, title, spocImageSettingsFields, spocLayout, hideTitleOnSpoc, urlLink, ...rest} = this.props;
        const spocLayoutClassName = _.kebabCase(spocLayout.toLowerCase());

        const infoDiv = (
            <div className="info">
                {!hideTitleOnSpoc && <div className="title" style={_.get(fontSettings, 'title')}>{title}</div>}
                {(!hideTitleOnSpoc || spocLayout === 'VISUAL_ON_TOP') && <div className="section-underline"/>}
                <div className="description" style={_.get(fontSettings, 'description')} dangerouslySetInnerHTML={{ __html: formatDescription(description) }}></div>
                <div className="details" style={_.get(fontSettings, 'details')}>
                    {this.getOptionalFields(rest)}
                </div>
            </div>
        );

        return (
            <SlideContainer className={`event ${spocLayoutClassName}`} {...this.props} >
            <div onClick={() => handleClick(urlLink)}>
                { spocLayoutClassName === 'title-on-top' ? infoDiv : null }
                <div className="image-wrapper">
                    <img
                        alt="event"
                        className="image"
                        onLoad={onLoad}
                        src={this.state.imageUrl}
                        style={styles.slideImage(spocImageSettingsFields)}
                    />
                    {do {
                        if (this.props.time && this.props.isCountdown) {
                            <Countdown time={this.props.time}/>;
                        }
                    }}
                </div>
                { spocLayoutClassName !== 'title-on-top' ? infoDiv : null }            
            </div>
            </SlideContainer>
        );
    }
}

SpocEventSlide.propTypes = {
    description: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]),
    fontSettings: PropTypes.object,
    image: PropTypes.string,
    spocImageSettingsFields: PropTypes.object,
    isCountdown: PropTypes.bool,
    location: PropTypes.string,
    onLoad: PropTypes.func,
    time: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.string
    ]),
    title: PropTypes.string,
    hideTitleOnSpoc: PropTypes.bool,
    urlLink : PropTypes.string
};

export default withFirebase(SpocEventSlide);



// WEBPACK FOOTER //
// ./src/components/dashboard/slides/SpocEventSlide.js